import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPlannedStockAction implements BaseEnumType {
  private static allValues: EnumPlannedStockAction[] = []; // make sure this is top-most
  
  public static enterIntoPlanned = new EnumPlannedStockAction(80, "EnterIntoPlanned", "enum_planned_stock_action_enter_into_planned");
  public static removeFromPlanned = new EnumPlannedStockAction(82, "RemoveFromPlanned", "enum_planned_stock_action_remove_from_planned");
  public static enterIntoStock = new EnumPlannedStockAction(83, "EnterIntoStock", "enum_planned_stock_action_enter_into_stock");
  public static removeFromStock = new EnumPlannedStockAction(88, "RemoveFromStock", "enum_planned_stock_action_remove_from_stock");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPlannedStockAction.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isEnterIntoPlanned() { return this === EnumPlannedStockAction.enterIntoPlanned; }
  public isRemoveFromPlanned() { return this === EnumPlannedStockAction.removeFromPlanned; }
  public isEnterIntoStock() { return this === EnumPlannedStockAction.enterIntoStock; }
  public isRemoveFromStock() { return this === EnumPlannedStockAction.removeFromStock; }

  public static getValues(): readonly EnumPlannedStockAction[] {
    return EnumPlannedStockAction.allValues;
  }

  public static getValuesExcept0(): readonly EnumPlannedStockAction[] {
    return EnumPlannedStockAction.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPlannedStockAction {
    const found = EnumPlannedStockAction.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPlannedStockAction - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPlannedStockAction): EnumPlannedStockAction {
    const found = name ? EnumPlannedStockAction.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPlannedStockAction - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPlannedStockAction>): boolean {
    return this.key === other?.key;
  }
}